export enum IconType {
  Alert = 'Alert',
  Announcement = 'Announcement',
  ArrowDown = 'Arrow-Down',
  ArrowLeft = 'Arrow-Left',
  ArrowRight = 'Arrow-Right',
  ArrowUp = 'Arrow-Up',
  Attachment = 'Attachment',
  AutoRenew = 'Auto-Renew',
  Back = 'Back',
  BookmarkFill = 'Bookmark-Fill',
  BookmarkLine = 'Bookmark-Line',
  Calendar = 'Calendar',
  Celebrate = 'Celebrate',
  CaretDd = 'caret-dd',
  Check = 'Check',
  CheckCircleFill = 'Check-Circle-Fill',
  CheckCircleLine = 'Check-Circle-Line',
  CloseCircleFill = 'Close-Circle-Fill',
  CloseCircleLine = 'Close-Circle-Line',
  Comment = 'Comment',
  Contract = 'Contract',
  Copy = 'Copy',
  Delivering = 'Delivering',
  Doc = 'Doc',
  DocError = 'Doc-Error',
  DocView = 'Doc-View',
  DollarSign = 'Dollar-Sign',
  Edit = 'Edit',
  Enlarge = 'Enlarge',
  Escape = 'Escape',
  Filter = 'Filter',
  Folder = 'Folder',
  FolderOpen = 'Folder-Open',
  Folders = 'Folders',
  Forward = 'Forward',
  GraphBar = 'Graph-Bar',
  GraphLIne = 'Graph-Line',
  Grid = 'Grid',
  HamburgerMenu = 'Hamburger-Menu',
  HeartFill = 'Heart-Fill',
  HeartLine = 'Heart-Line',
  Help = 'Help',
  History = 'History',
  Home = 'Home',
  House = 'House',
  Image = 'Image',
  Inbox = 'Inbox',
  InfoFill = 'Info-Fill',
  InfoLine = 'Info-Line',
  Key = 'Key',
  KeyAlt = 'Key-Alt',
  Leaf = 'Leaf',
  Link = 'Link',
  List = 'List',
  Loading = 'Loading',
  LockFill = 'Lock-Fill',
  LockLine = 'Lock-Line',
  LockOpen = 'Lock-Open',
  MailFill = 'Mail-Fill',
  MailLine = 'Mail-Line',
  Map = 'Map',
  MapMarker = 'Map-Marker',
  Mode = 'Mode',
  MoreOptions = 'More-Options',
  Move = 'Move',
  NotificationFill = 'Notification-Fill',
  NotificationLine = 'Notification-Line',
  OutboundLink = 'Outbound-Link',
  Overflow = 'Overflow',
  Party = 'Party',
  Phone = 'Phone',
  PieChart = 'Pie-Chart',
  Plus = 'Plus',
  Preferences = 'Preferences',
  Print = 'Print',
  Prohibited = 'Prohibited',
  Publish = 'Publish',
  Refresh = 'Refresh',
  Remove = 'Remove',
  ResendInvite = 'ResendInvite',
  Required = 'Required',
  Rocket = 'Rocket',
  Search = 'Search',
  Selector = 'Selector',
  Send = 'Send',
  Settings = 'Settings',
  Share = 'Share',
  Signature = 'Signature',
  SprucePowered = 'SprucePowered',
  Squiggle = 'Squiggle',
  SquiggleAlt = 'Squiggle-Alt',
  Stack = 'Stack',
  StackAlt = 'Stack-Alt',
  Stamp = 'Stamp',
  StarFill = 'Star-Fill',
  StarLine = 'Star-Line',
  Team = 'Team',
  ThumbsUp = 'Thumbs-Up',
  Time = 'Time',
  UnitedStates = 'United-States',
  Unpublish = 'Unpublish',
  Upload = 'Upload',
  UserFill = 'User-Fill',
  UserLine = 'User-Line',
  Verified = 'Verified',
  Warning = 'Warning',
  ZigZag = 'Zig-Zag',
  ZoomIn = 'Zoom-In',
  ZoomOut = 'Zoom-Out',
}

export const defaultGrayIcons = [
  IconType.Move,
  IconType.Escape,
  IconType.ArrowLeft,
  IconType.ArrowRight,
  IconType.ArrowUp,
  IconType.ArrowDown,
];

export const defaultWarningIcons = [IconType.Prohibited, IconType.Warning, IconType.Alert];

export const defaultErrorIcons = [IconType.DocError, IconType.Remove, IconType.CloseCircleLine];

export const defaultBlackIcons = [IconType.CaretDd, IconType.ResendInvite];
